export const SEARCH_PLACEHOLDER = {
  Genes: {
    default: 'Search for gene(s), ex: ABCA4, ABCA5',
    mobile: 'Search for gene(s)',
  },
  Panel: {
    default: 'Search for panel, ex: epilepsy',
    mobile: 'Search for panel',
  },
};
